import React, { useState, useEffect } from "react";
import { api } from "../../../api";
import { useQuery } from "react-query";
import { Link } from "react-router-dom";
import Card from "./components/Card";
import { AssessementContext } from "../assessments/AssessmentContext";
import { defaultState } from "../assessments/components/defaultState";
import { exams as examsApi } from "../../../api/exams";
import { useTranslation } from 'react-i18next';
import i18n from "../../../i18n";
import Loader from "../../../components/loader/Loader";
import Pagination from "../../../components/Pagination/Pagination";
import Input from "../../../components/input/Input";
import EmptyData from "../../../components/EmptyData";
import SurveyCard from "./components/SurveyCard";
const Dashboard = ({ width }) => {

  const [assessment, setAssessment] = useState(defaultState);
  const [showRedirect, hideRedirect] = useState(false);
  const user = JSON.parse(sessionStorage.getItem('user'))
  const { t, i18n: i18nNext, } = useTranslation();
   const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(30);
  const [search, setSearch] = useState('')

  const { isLoading: surveysLoading, data: surveys } = useQuery(
    ["user exams", currentPage, perPage, search],
    async () => {
      const data = await examsApi.getSurveys({
        type: null, id: user?.user?.user_id, currentPage , perPage, search
      });
      return data;
    },  
    {
      select: (data) => data,
      refetchOnWindowFocus: false,
    }
  );  

  const { data: summaryData, isLoading: summaryLoading } = useQuery(
    ["Summary Data"],
    async () => {
      const data = await api.getDashboardSummary(user?.user?.user_id);
      return data;
    },
    {
      select: (response) => response?.data,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );

  useEffect(() => {
    hideRedirect(true);
  }, []);

  return (
    <React.Fragment>
      <AssessementContext.Provider value={{ assessment, setAssessment }}>
        {(
          <>
            {/*( showRedirect && mockAssessment?.length) ? 
               <Redirect handleRedirect={hideRedirect} /> : null 
           */}
            <div
              className="mt-1 gap-4"
              style={{
                display: "flex",
                width: "100%",
                // gridTemplateColumns: width > 768 ? "4fr 1.5fr" : "1fr",
              //  border: "1px solid #ccc",
              }}
            >
              <div className="w-full md:pt-0">
                {/*WELCOME SECTION*/}
                <div className="md:flex items-center justify-between w-full">
                  <div>
                    <h1
                      className="text-darkBlue"
                      style={{ fontSize: "25px", marginTop: "10px" }}
                    >
                      {t('welcome')}, {user?.user?.name || user?.name}!
                    </h1>
                  </div>
                </div>
                <div className="bg-white mt-3 py-8 px-3 mb-12 justify-between grid gap-5 grid-cols-1 md:grid-cols-4">
                <Card
                    title={'Total Surveys'}
                    text={summaryData?.totalSurveys || 0}
                    color="text-gray-900"
                    bgColor={'bg-gray-50'}
                    isLoading={false}
                  />
                  <Card
                    title={'Not Started'}
                    text={summaryData?.totalNotStartedSurveys || 0}
                    bgColor={'bg-blue-50'}
                    color="text-blue-500"
                  />
                  <Card
                    title={'In Progress'}
                    text={summaryData?.totalInProgressSurveys || 0}
                    bgColor={'bg-orange-50'}
                    color="text-orange-500"
                  />
                  <Card
                    title={'In Progress'}
                    bgColor={'bg-green-50'}
                    text={summaryData?.totalCompletedSurveys || 0}
                    isLoading={false}
                    color="text-[#87AA4B]"
                  />
                </div>
                <section>
                     <div className="md:flex items-center justify-between mb-3">
                      <h5 className="max-[500px]:mb-3 text-xl font-semibold">
                         My Surveys
                      </h5>
                      <div className="w-[300px] text-slate-950">
                          <Input 
                            type='search'
                            placeholder={'Search Surveys'}
                            onChange={ event => setSearch(event.target.value)}
                          />
                    </div>
                    </div>
                  {
                    surveysLoading ? (
                      <Loader />
                    ) : 
                     !surveys?.data?.length > 0 ? (
                        <EmptyData text={'No Surveys Found'} />
                     ) :
                    <div className="mb-12 grid gap-5 grid-cols-1 md:grid-cols-3">
                      {
                        surveys?.data?.map((survey, index) => (
                           <SurveyCard survey={survey} key={survey?.id} />
                        ))
                      }
                  </div>
                      
                  }
                </section>
                 <Pagination
                      data={surveys?.meta}
                      perPage={perPage}
                      pageNo={currentPage}
                      setPageNo={setCurrentPage}
                      setPerPage={setPerPage}
                  />
              </div>
            </div>
          </>
        )}
      </AssessementContext.Provider>
    </React.Fragment>
  );
};

export default Dashboard;
